import '../scss/index.scss';
import './_init';
import { SmartMTEditorPopup } from './_editor_popup';
import { Crop } from './_crop';
import { Rotate } from './_rotate';
import { Resize } from './_resize';
import { Effects } from './_effects';
import { Compress } from './_compress';
import { Convert } from './_convert';
import { getAttachment } from './_utils';
// import { RemoveBackground } from './_removeBackground';


/**
 * Exported functions - availabe in the SmartMT library object.
 * 
 * Usage example: SmartMT.load(attachment);
 */
export const load = (attachment = false) => {
    const currentURL = window.location.href;
    if (attachment === false) {
        attachment = getAttachment();
        if (!attachment) {
            console.error("Failed to retrieve attachment from localStorage.");
            return;
        }
    } else {
        localStorage.setItem('smart-mt-attachment', JSON.stringify(attachment));
    }

    let content = imDefaultContent(attachment);
    let sidebar = imDefaultSidebar(attachment);

    SmartMTEditorPopup(content, sidebar);
    if (!currentURL.includes('wp-admin/post.php?post=')) {
        jQuery('.media-modal-close').click();
    }

    // Loading tools.
    Crop(attachment);
    Rotate(attachment);
    Resize(attachment);
    Effects(attachment);
    Compress(attachment);
    Convert(attachment);
    // RemoveBackground(attachment);
};

/**
 * Default content for the popup.
 * @param {object} attachment 
 * @returns {string}
 */
const imDefaultContent = (attachment) => {
    return `
        <div class="smart-mt-content smart-mt-content-default">
            <img src="${attachment.url}" alt="${attachment.name}">
        </div>`;
};

/**
 * Default content for the popup sidebar.
 * @param {object} attachment 
 * @returns {string} HTML sidebar content.
 */
const imDefaultSidebar = (attachment) => {
    return `
        <div class="smart-mt-sidebar smart-mt-sidebar-default">
            <h3>${attachment.filename}</h3>
            <ul class="smart-mt-file-details">
                <li><strong>Title: </strong><span>${attachment.name}</span></li>
                <li><strong>Size: </strong><span>${attachment.filesizeHumanReadable}</span></li>
                <li><strong>Width: </strong><span>${attachment.width} px</span></li>
                <li><strong>Height: </strong><span>${attachment.height} px</span></li>
                <li><strong>Uploaded by: </strong><span>${attachment.authorName}</span></li>
            </ul>
        </div>`;
};

// window.SmartMT = {
//     load
// };

jQuery(document).ready(() => {
    const $ = jQuery;

    $('.edit-with-smartmt').on('click', function () {
        const attachmentId = $(this).data('attachment-id');
        const attachmentUrl = $(this).data('attachment-url');

        if (!attachmentId || !attachmentUrl) {
            alert("Failed to load the attachment. Please try again.");
            console.error("Missing attachment ID or URL for Smart Media Tools.");
            return;
        }

        const attachment = { id: attachmentId, url: attachmentUrl };

        try {
            load(attachment);
        } catch (error) {
            console.error("Error loading Smart Media Tools editor:", error);
        }
    });
});
